// Scheme guard against `javascript:` / `data:` payloads landing in href/src
// when third-party API responses (trbo, FactFinder) are spoofed or compromised.
// Allows https and same-origin relative paths only.
export function isSafeUrl(url: string): boolean {
    if (!url) {
        return false;
    }
    try {
        const parsed = new URL(url, window.location.href);
        return parsed.protocol === 'https:' || parsed.origin === window.location.origin;
    } catch {
        return false;
    }
}
